const images = [
  {
    original: require("../../jpg/bear-d1x.jpg"),
    thumbnail: require("../../jpg/bear-d2x.jpg"),
  },
  {
    original: require("../../jpg/медведи.jpg"),
    thumbnail: require("../../jpg/медведи.jpg"),
  },
  {
    original: require("../../jpg/ленивец.jpg"),
    thumbnail: require("../../jpg/ленивец.jpg"),
  },
  {
    original: require("../../jpg/ежики.jpg"),
    thumbnail: require("../../jpg/ежики.jpg"),
  },
  {
    original: require("../../jpg/поросята.jpg"),
    thumbnail: require("../../jpg/поросята.jpg"),
  },
  {
    original: require("../../jpg/дружная-семейка.jpg"),
    thumbnail: require("../../jpg/дружная-семейка.jpg"),
  },
  {
    original: require("../../jpg/бабушка.jpg"),
    thumbnail: require("../../jpg/бабушка.jpg"),
  },
  {
    original: require("../../jpg/девочка-гуляет-с-собакой.jpg"),
    thumbnail: require("../../jpg/девочка-гуляет-с-собакой.jpg"),
  },
  {
    original: require("../../jpg/девочка-на-дереве.jpg"),
    thumbnail: require("../../jpg/девочка-на-дереве.jpg"),
  },
  {
    original: require("../../jpg/девочка-на-подоконнике.jpg"),
    thumbnail: require("../../jpg/девочка-на-подоконнике.jpg"),
  },
  {
    original: require("../../jpg/девочка.jpg"),
    thumbnail: require("../../jpg/девочка.jpg"),
  },
  {
    original: require("../../jpg/дядя.jpg"),
    thumbnail: require("../../jpg/дядя.jpg"),
  },
  {
    original: require("../../jpg/школьники.jpg"),
    thumbnail: require("../../jpg/школьники.jpg"),
  },
  {
    original: require("../../jpg/циплята.jpg"),
    thumbnail: require("../../jpg/циплята.jpg"),
  },
  {
    original: require("../../jpg/семья-собралась-вместе.jpg"),
    thumbnail: require("../../jpg/семья-собралась-вместе.jpg"),
  },
];

export default images;
